import "@/App.css";
import PasswordGate from "@/components/PasswordGate";
import PitchDeck from "@/components/PitchDeck";

function App() {
  return (
    <div className="App">
      <PasswordGate>
        <PitchDeck />
      </PasswordGate>
    </div>
  );
}

export default App;
